export default __webpack_public_path__ + "static/media/prototyping-principles.fadd7979.svg";